import striptags from 'striptags';
import htmlEntitiesDecode from '../core/htmlEntitiesDecode';

export function formatContent<T>(content: T) {
  if (typeof content === 'string') {
    return htmlEntitiesDecode(striptags(content));
  }
  return content;
}
